import React, { useState } from "react";
import DefaultLayout from "../Layout/DefaultLayout";
import { ManageUserContainer } from "./AdminStyle.styled";
import { Row, Col, Button, Table, Modal, Tag } from "antd";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { AdminDeleteOneUser } from "../../../redux/actions/adminOtherServices";
import { Delete, Edit, Add } from "@mui/icons-material";
import CreateAdminModal from "../admins/CreateAdminModal";

const AdminManageAdmins = (props) => {
  const { AdminDeleteOneUser } = props;
  // const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [adminRecord, setAdminRecord] = useState(null);
  const [formMode, setFormMode] = useState("CREATE_MODE");
  const [defaultAdmins, setDefaultAdmins] = useState([
    {
      id: 1,
      firstName: "Adetayo",
      lastName: "Adetokun",
      email: "adetayoadetokun@gmail.com",
      roleName: "Support",
      roleId: "1",
      phoneNumber: "07064907892",
    },
    {
      id: 2,
      firstName: "Chymdy",
      lastName: "Ugah",
      email: "ugahchymdy.com",
      roleName: "Super",
      roleId: "2",
      phoneNumber: "07046573822",
    },
    {
      id: 3,
      firstName: "Control",
      lastName: "Admin",
      email: "controladmin@gmail.com",
      roleName: "Control",
      roleId: "3",
      phoneNumber: "07046573822",
    },
  ]);

  const CreateAdmin = () => {
    setVisible(true);
    setFormMode("CREATE_MODE");
    setAdminRecord(null);
  };

  const editRecord = async (record) => {
    setAdminRecord(record);
    setVisible(true);
    setFormMode("UPDATE_MODE");
  };

  const closeModal = () => {
    setVisible(false);
    setFormMode("CREATE_MODE");
    setAdminRecord(null);
  };

  const confirmDelete = (record) => {
    Modal.confirm({
      title: "Do you want to delete this admin?",
      content: "Click delete to proceed",
      okText: "Delete",
      loading: deleteLoading,
      okType: "danger",
      async onOk() {
        setDeleteLoading(true);
        const filteredAdmins = defaultAdmins?.filter(
          (el) => el?.id !== record?.id
        );
        setDefaultAdmins(filteredAdmins);
        setDeleteLoading(false);
        toast.success("Admin Deleted Successfully ", {
          pauseOnHover: false,
        });

        // const res = await AdminDeleteOneUser(record.id);
        // if (res.success) {
        //   setDeleteLoading(false);
        //   toast.success("Admin Deleted Successfully ", {
        //     pauseOnHover: false,
        //   });
        // } else {
        //   toast.info(res.message, {
        //     pauseOnHover: true,
        //   });
        // }
      },
      onCancel() {
        setDeleteLoading(false);
        return false;
      },
    });
  };

  const adminCol = [
    {
      title: "Last Name",
      dataIndex: "lastName",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Role Type",
      dataIndex: "roleName",
      align: "center",
      render: (_text, record) => (
        <>
          {record.roleName === null ? (
            <Tag color="gray">Unknown</Tag>
          ) : record.roleName === "Support" ? (
            <Tag color="blue">{record?.roleName}</Tag>
          ) : record.roleName === "Control" ? (
            <Tag color="orange">{record?.roleName}</Tag>
          ) : (
            <Tag color="green">{record?.roleName}</Tag>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_text, record) => (
        <>
          <div className="actiontable">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <button className="eid" onClick={() => editRecord(record)}>
              <Edit />
            </button>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <button className="del" onClick={() => confirmDelete(record)}>
              <Delete />
            </button>
          </div>
        </>
      ),
    },
  ];

  return (
    <DefaultLayout browserTitle="Manage Users">
      <ManageUserContainer data-aos="fade-right">
        <h3>Manage Admins</h3>

        <Row>
          <Col xs={24}>
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Button
                onClick={CreateAdmin}
                icon={<Add style={{ marginRight: "8px" }} />}
                type="primary"
              >
                {" "}
                Add Admin
              </Button>
            </div>
          </Col>
        </Row>
        <Table
          // loading={loading}
          style={{ overflowX: "auto" }}
          rowKey="id"
          columns={adminCol}
          dataSource={defaultAdmins}
        />

        <CreateAdminModal
          visible={visible}
          closeModal={closeModal}
          formMode={formMode}
          one_admin={adminRecord}
          setDefaultAdmins={setDefaultAdmins}
          defaultAdmins={defaultAdmins}
        />
      </ManageUserContainer>
    </DefaultLayout>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  AdminDeleteOneUser,
})(AdminManageAdmins);
